import Network from '@/Network'
import { AuthorizationResourcesAndSubjects, AuthorizationRelations } from '@/types/authorization'
import { UpsertPermissionsRequest } from '@/Network/Types/Requests/AuthorizationRequests'
import { ModuleTypeStrategy, PermissionOption } from './ModuleTypeStrategy'

/**
 * Grupo de permissão "Documentação" (D112): Leitor, Editor e Administrador de Documentação,
 * só no nível Empresa (`professional_documents_company`, id = o da empresa).
 */
const PERMISSIONS_FOR_NEW_USERS: PermissionOption[] = [
  { label: 'Leitor de Documentação', value: AuthorizationRelations.DocumentationReader },
  { label: 'Editor de Documentação', value: AuthorizationRelations.DocumentationEditor },
  {
    label: 'Administrador de Documentação',
    value: AuthorizationRelations.DocumentationAdministrator
  }
]

const PERMISSIONS_FOR_SELECT: PermissionOption[] = [
  { label: 'Proprietário', value: AuthorizationRelations.Parent, disabled: true },
  ...PERMISSIONS_FOR_NEW_USERS
]

export class DocumentationStrategy implements ModuleTypeStrategy {
  getPermissionsForNewUsers(): PermissionOption[] {
    return PERMISSIONS_FOR_NEW_USERS
  }

  getPermissionsForSelect(): PermissionOption[] {
    return PERMISSIONS_FOR_SELECT
  }

  getDefaultPermission(): AuthorizationRelations {
    return AuthorizationRelations.DocumentationReader
  }

  resolveResourceType(): AuthorizationResourcesAndSubjects {
    return AuthorizationResourcesAndSubjects.ProfessionalDocumentsCompany
  }

  async addPermissions(resourceId: number, _companyId: number, payload: UpsertPermissionsRequest) {
    await Network.permission.addProfessionalDocumentsCompanyPermissions(resourceId, payload)
  }

  async upsertPermissions(
    resourceId: number,
    _companyId: number,
    payload: UpsertPermissionsRequest
  ) {
    await Network.permission.upsertProfessionalDocumentsCompanyPermissions(resourceId, payload)
  }
}
